// Custom Forcefield Logo Component for Social Forcefield brand
export const ForcefieldLogo = ({ className = "w-9 h-9" }) => (
  <div className={`${className} relative flex items-center justify-center`}>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      {/* Outer ring - animated */}
      <circle 
        cx="20" 
        cy="20" 
        r="18" 
        stroke="url(#forcefield-gradient)" 
        strokeWidth="2" 
        strokeDasharray="4 2"
        className="origin-center"
        style={{ animation: 'spin 20s linear infinite' }}
      />
      {/* Middle ring */}
      <circle cx="20" cy="20" r="13" stroke="url(#forcefield-gradient)" strokeWidth="1.5" opacity="0.6" />
      {/* Inner shield/core */}
      <path 
        d="M20 8C20 8 28 12 28 20C28 28 20 32 20 32C20 32 12 28 12 20C12 12 20 8 20 8Z" 
        fill="url(#forcefield-gradient)" 
      />
      {/* Center dot */}
      <circle cx="20" cy="20" r="3" fill="white" opacity="0.9" />
      <defs>
        <linearGradient id="forcefield-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8B5CF6" />
          <stop offset="100%" stopColor="#D946EF" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);

export const ForcefieldLogoSmall = ({ className = "w-7 h-7" }) => (
  <div className={`${className} relative flex items-center justify-center`}>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <circle cx="20" cy="20" r="17" stroke="url(#forcefield-gradient-sm)" strokeWidth="2.5" strokeDasharray="3 2" />
      <path 
        d="M20 9C20 9 27 12.5 27 20C27 27.5 20 31 20 31C20 31 13 27.5 13 20C13 12.5 20 9 20 9Z" 
        fill="url(#forcefield-gradient-sm)" 
      />
      <circle cx="20" cy="20" r="2.5" fill="white" opacity="0.9" />
      <defs>
        <linearGradient id="forcefield-gradient-sm" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8B5CF6" />
          <stop offset="100%" stopColor="#D946EF" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);
